import { Stepper as MantineStepper } from '@mantine/core'

import { StepperProps } from './stepper.types'

export const Stepper = ({ ...props }: StepperProps) => (
  <MantineStepper {...props} />
)
